import PuzzleShell from '../../components/PuzzleShell';

export default function SudokuPlayer({ puzzle, adapter }) {
  return <PuzzleShell puzzle={puzzle} adapter={adapter} />;
}
